// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SocialShare_wrapper__1bHa1","link":"SocialShare_link__2c47W"};